import { Injectable } from '@angular/core';
import { BaseService } from '../../../../shared/services/base.service';
import { ValidationService } from '../../../../shared/services/validation.service';
import { IndividualWaitingModel } from "../../../../models/waiting-room/individual-waiting.model";
import { ConsultationType, ConsultationValue } from "../../../../models/consultation/consultation.model";
import { CentreUrl } from '../../../../shared/urls/centre.url';
@Injectable()
export class PreviousWaitingRoomService {
    constructor(public baseService: BaseService) {
    }

    getPreviousWaitingList(param) {
        let url = CentreUrl.GET_PREVIOUS_WAITING_ROOM;
        return this.baseService.getData(url, param);
        //return data;
    }

    validateDateRange(fromDateControl, toDateControl, isFromDateActive) {
        if (ValidationService.isValidDate(fromDateControl) || ValidationService.isValidDate(toDateControl)) {
            return;
        }
        //validate fromDate < toDate
        console.log(ValidationService.compareDate(fromDateControl, toDateControl));
        if (ValidationService.compareDate(fromDateControl, toDateControl) == 1) {
            if (isFromDateActive) {
                fromDateControl.setErrors({ 'invalidDateRangeWaitingRoom': true });
            } else {
                toDateControl.setErrors({ 'invalidDateRangeWaitingRoom': true });
            }

        } else {
            fromDateControl.setErrors(null);
            toDateControl.setErrors(null);
            //validate The date range must bbe within 6 months
            let rangeMonth = new Date(fromDateControl.value);
            rangeMonth.setMonth(fromDateControl.value.getMonth() + 6);
            rangeMonth.setHours(0, 0, 0);
            if (rangeMonth.getTime() < toDateControl.value.getTime()) {
                if (isFromDateActive) {
                    fromDateControl.setErrors({ 'invalidMonthRangeWaitingRoom': true });
                } else {
                    toDateControl.setErrors({ 'invalidMonthRangeWaitingRoom': true });
                }
            }
        }

    }

    addPatientToWaitingRoom(patientId: string, clinicId: string) {
        var url = CentreUrl.ADD_PATIENT_TO_WAITING_ROOM.replace('{patientId}', patientId);
        if (clinicId && clinicId !== "null") {
            url = url + "?clinicId=" + clinicId;
        }
        return this.baseService.postData(url, null);
    };
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation/waiting-room/previous-waiting-room/previous-waiting-room.service.ts